import { browserTracingIntegration } from "@sentry/browser";
import * as Sentry from "@sentry/react";

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	integrations: [browserTracingIntegration()],
	tracesSampleRate: 0.5
});
